import React, { useState } from 'react';
import BusinessAnalysisCard from './BusinessAnalysisCard';
import ObjectiveCard from './ObjectiveCard';
import { FaChartLine, FaBullseye, FaLightbulb } from 'react-icons/fa';

const AnalysisStep = ({ sessionId, businessAnalysis, objectives, onObjectiveSelect, loading }) => {
    const [selectedObjectiveId, setSelectedObjectiveId] = useState(null);
    const [expandedAnalysis, setExpandedAnalysis] = useState(false);

    const handleObjectiveSelect = (objectiveId) => {
        setSelectedObjectiveId(objectiveId);
        onObjectiveSelect(objectiveId);
    };

    return (
        <div className="space-y-8">
            {/* Header */}
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                        <FaChartLine className="text-green-500 text-2xl" />
                    </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    Análisis de tu Negocio
                </h2>
                <p className="text-gray-600">
                    Hemos analizado tus datos y encontrado oportunidades de crecimiento
                </p>
            </div>

            {/* Business Analysis */}
            {businessAnalysis && (
                <div className="mb-8">
                    <BusinessAnalysisCard
                        analysis={businessAnalysis}
                        expanded={expandedAnalysis}
                        onToggle={() => setExpandedAnalysis(!expandedAnalysis)}
                    />
                </div>
            )}

            {/* Objectives Section */}
            <div className="bg-white rounded-lg shadow-lg p-8">
                <div className="flex items-center mb-6">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                        <FaBullseye className="text-blue-500 text-xl" />
                    </div>
                    <div>
                        <h3 className="text-xl font-bold text-gray-900">
                            Objetivos Identificados
                        </h3>
                        <p className="text-gray-600">
                            Selecciona el objetivo que mejor se alinee con tus prioridades
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {objectives && objectives.map((objective, index) => (
                        <ObjectiveCard
                            key={objective.id}
                            objective={objective}
                            selected={selectedObjectiveId === objective.id}
                            onSelect={handleObjectiveSelect}
                            priority={index + 1}
                        />
                    ))}
                </div>

                {selectedObjectiveId && (
                    <div className="mt-8 text-center">
                        <div className="flex items-center justify-center mb-4">
                            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                <FaLightbulb className="text-green-500 text-xl" />
                            </div>
                            <div className="text-left">
                                <h4 className="font-semibold text-gray-900">
                                    Objetivo Seleccionado
                                </h4>
                                <p className="text-sm text-gray-600">
                                    Continuando con la generación de estrategias...
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AnalysisStep; 